import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportSectionDataSection,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PriceActivityModel } from './price-activity.model';

export class DRPriceVolumeConfiguration extends ReportSectionConfigurationBase {
  readonly reportViewModelSections = [ReportViewModelSection.BnyManagementReport_DRPriceVolume];
  typeName = 'DRPriceVolumeConfiguration';
  nodataLocalizationKeyName = 'bnyDailyPriceVolume';
  readonly reportSection = ReportSection.DrPriceVolume;
  readonly applicableReportTypes = [ReportType.BnyManagementReport];
  maxSize = 4;
  defaultSize = 4;
  minSize = 2;
  name = 'drPriceVolume';
  displayName = 'Daily DR Price & Volume';
  readonly availableDataSections: ReportSectionDataSection[] = [];
}

export interface DRPriceVolumeDetailsData {
  [ReportViewModelSection.BnyManagementReport_DRPriceVolume]: PriceActivityModel;
}
